module.exports = __webpack_public_path__ + "static/media/finances-tutorial2.15fb50fc.png";